import React from 'react';
import './Tag.css';

export default function Tag( { title, variant }) {
  return (
    <div className={`Tag ${variant === 'primary' ? 'tag-primary' : ''}`}> 
      <p className='text-1'> { title } ↗ </p>
    </div>
  )
}
